/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BeginChatResponse
 */
export interface BeginChatResponse {
    /**
     * 
     * @type {string}
     * @memberof BeginChatResponse
     */
    thread: string;
    /**
     * 
     * @type {string}
     * @memberof BeginChatResponse
     */
    title: string;
}

/**
 * Check if a given object implements the BeginChatResponse interface.
 */
export function instanceOfBeginChatResponse(value: object): value is BeginChatResponse {
    if (!('thread' in value) || value['thread'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function BeginChatResponseFromJSON(json: any): BeginChatResponse {
    return BeginChatResponseFromJSONTyped(json, false);
}

export function BeginChatResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeginChatResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'thread': json['thread'],
        'title': json['title'],
    };
}

export function BeginChatResponseToJSON(json: any): BeginChatResponse {
    return BeginChatResponseToJSONTyped(json, false);
}

export function BeginChatResponseToJSONTyped(value?: BeginChatResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'thread': value['thread'],
        'title': value['title'],
    };
}

